import { Avatar } from "primereact/avatar";
import MeaLink from "./MeaLink";
import { useAuthContext } from "../hooks/useAuthContext";

const MeaMemberAvatar = ({ member, permission, noNavigation }) => {
  const { currentMembership } = useAuthContext();
  const schoolId = currentMembership?.school_id;
  return (
    member !== null &&
    member !== undefined &&
    ((
      <MeaLink to={"/school/" + schoolId + "/admin/members/" + member?.id} permission={permission}
        noNavigation={noNavigation}>
        <Avatar
          className="mr-2 p-overlay-badge"
          icon="pi pi-user"
          shape="circle"
          image={
            member?.avatar
              ? member?.avatar + "?u=" + member?.updated_at
              : ""
          }
          label={
            member?.lastname
              ? Array.from(member?.lastname)[0] +
              (member?.firstname ? Array.from(member?.firstname)[0] : "")
              : member?.name
                ? Array.from(member?.name)[0]
                : ""
          }
          size="normal"
        ></Avatar>
        <span>
          {member?.name || member?.lastname + " " + member?.firstname}
        </span>
      </MeaLink>
    ) || <>-</>)
  );
};
export default MeaMemberAvatar;
